import script from "./ApiPingList.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiPingList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__